import axios from 'axios';

export const GET_CONFIG = 'GET_CONFIG';
export const GET_CONFIG_PENDING = `${GET_CONFIG}_PENDING`;
export const GET_CONFIG_REJECTED = `${GET_CONFIG}_REJECTED`;
export const GET_CONFIG_FULFILLED = `${GET_CONFIG}_FULFILLED`;

export default function getConfig() {
  return {
    type: GET_CONFIG,
    payload: axios.get(`${process.env.REACT_APP_CONFIG_SERVICE_ENDPOINT}`, {
      headers: {
        'Customer-Facing-Tool': "CSAWEB",
        CFT: "CSAWEB",
      },
    }),
  };
}
